import React__default from 'react';
import _s, { css } from 'styled-components';

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Divider = () => {
  return /*#__PURE__*/React__default.createElement(Container, null);
};
const Container = styled.div`
  ${({
  theme
}) => css(["background-color:", ";height:", "px;"], theme.borderColors.primary, theme.borderWidths.base)}
`;

export { Divider as default };
//# sourceMappingURL=Divider.js.map
